import { Font, StyleSheet } from '@react-pdf/renderer';

import figtree500 from '../../assets/fonts/pdf/Figtree-500.ttf';
import figtree700 from '../../assets/fonts/pdf/Figtree-700.ttf';
import figtree900 from '../../assets/fonts/pdf/Figtree-900.ttf';

// Shared look of the exported PDFs (gym sheet and meal plan): the app's type and colours, set for paper

Font.register({
  family: 'Figtree',
  fonts: [
    { src: figtree500, fontWeight: 500 },
    { src: figtree700, fontWeight: 700 },
    { src: figtree900, fontWeight: 900 },
  ],
});
// Whole words only: the default splits Portuguese words with stray hyphens
Font.registerHyphenationCallback((word) => [word]);

export const C = {
  ink: '#0F1115',
  ink2: '#4B5563',
  ink3: '#8A909C',
  line: '#E4E6EA',
  field: '#C9CED6',
  tile: '#F1F3F5',
  surface: '#F7F8FA',
  green: '#12A150',
  greenInk: '#0A7B3A',
  greenTint: '#E8F5EC',
  amber: '#B45309',
  amberTint: '#FEF3E2',
};

export const MARGIN = 32;

export const base = StyleSheet.create({
  page: {
    paddingTop: MARGIN,
    paddingBottom: MARGIN + 18,
    paddingHorizontal: MARGIN,
    fontFamily: 'Figtree',
    fontWeight: 500,
    fontSize: 9,
    color: C.ink,
    backgroundColor: '#FFFFFF',
  },
});

export const today = (language) =>
  new Intl.DateTimeFormat(language === 'pt' ? 'pt-BR' : 'en-US', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(new Date());

// Exercise art from media.meutreino.fit: a separate URL so the edge cache only ever holds the CORS copy for it
export const pdfImage = (url) => (url ? `${url}${url.includes('?') ? '&' : '?'}pdf=1` : null);
